var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconChevronLeft = function SvgS2IconChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79 13.164a.596.596 0 0 1-.432-.185l-4.39-4.562a.598.598 0 0 1 0-.831l4.4-4.574a.599.599 0 1 1 .864.831l-4 4.158 3.99 4.147a.598.598 0 0 1-.432 1.016Z"
  })));
};
export default SvgS2IconChevronLeft;